<template>
  <div class="user-details" v-if="user">

    <div class="box">
      <div class="columns">
        <div class="column">
          <h2 class="subtitle">First Name</h2>
          <h1 class="title is-4">{{ user.firstName }}</h1>
        </div>
        <div class="column">
          <h2 class="subtitle">First Name</h2>
          <h1 class="title is-4">{{ user.lastName }}</h1>
        </div>
        <div class="column">
          <h2 class="subtitle">Username</h2>
          <h1 class="title is-4">{{ user.username }}</h1>
        </div>
      </div>
    </div>

    <div class="box">
      <div class="columns">
        <div class="column is-4">
          <h2 class="subtitle">Phone</h2>
          <h1 class="title is-4">{{ user.phone }}</h1>
        </div>
        <div class="column">
          <h2 class="subtitle">Address</h2>
          <h1 class="title is-4">{{ user.address }}</h1>
        </div>
      </div>
    </div>

    <div class="box">
      <div class="columns">
        <div class="column">
          <h2 class="subtitle">Overtime Paid Up To</h2>
          <h1 class="title is-4">{{ overtimePaidUpto }}</h1>
        </div>
        <div class="column">
          <h2 class="subtitle">Default Start Time</h2>
          <h1 class="title is-4">{{ user.defaultStartTime }}</h1>
        </div>
        <div class="column">
          <h2 class="subtitle">Default End Time</h2>
          <h1 class="title is-4">{{ user.defaultEndTime }}</h1>
        </div>
      </div>
    </div>

    <!-- EMERGENCY CONTACTS -->
    <div class="box">
      <h1 class="title is-4">Emergency Contacts</h1>
      <div class="columns is-multiline">
        <div class="column" v-if="!user.emergencyContacts || !user.emergencyContacts.length">NONE</div>
        <div class="column is-4" v-for="(contact, index) in user.emergencyContacts" :key="index">
          <h1 class="subtitle">{{ contact.name }}</h1>
          <h1 class="title is-4">{{ contact.phone }}</h1>
        </div>
      </div>
    </div>

    <!-- OTHER DETAILS -->
    <div class="box" v-if="user.otherDetails && user.otherDetails.length">
      <div class="columns is-multiline">
        <div class="column is-4" v-for="(detail, index) in user.otherDetails" :key="index">
          <h1 class="subtitle">{{ detail.key }}</h1>
          <h1 class="title is-4">{{ detail.value }}</h1>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'UserDetails',
  props: ['user'],
  computed: {
    overtimePaidUpto () {
      return this.user.overtimePaid ? this.$moment.unix(this.user.overtimePaid).format('DD/MM/YYYY') : '?'
    }
  }
}
</script>
